<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { getStr, isDirectionRTL } from '../../../common/util';
  import ExtraSnackBar from '../../common/components/ExtraSnackBar.svelte';
  import Icon from '../../common/components/Icon.svelte';
  import { showSnackbar } from '../../common/store/snackbar_store';
  import VDivider from './VDivider.svelte';

  export let couponData;

  // let snackbarWithoutClose: Snackbar;

  function onCopyCodeClicked() {
    navigator.clipboard.writeText(couponData.couponCode);
  }
</script>

<section class="coupon-container">
  <div class="coupon-div">
    <Icon glyph="icon-price_match" type="primary" mobileSize={16} desktopSize={24} />
    <div class="description">
      {#if isDirectionRTL()}
        <span>{@html couponData.label}</span>
        <a
          href="# "
          role="button"
          class="copy-code"
          on:click|preventDefault={onCopyCodeClicked}
          on:click={() => showSnackbar($_(getStr('pdp.couponCodeSuccess')), 'info')}>{couponData.copyText}</a
        >
      {:else}
        <span>{@html couponData.label}</span>
        <VDivider />
        <strong>"{couponData?.couponCode}"</strong>
        <a
          href="# "
          role="button"
          class="copy-code"
          on:click|preventDefault={onCopyCodeClicked}
          on:click={() => showSnackbar($_(getStr('pdp.couponCodeSuccess')), 'info')}>{couponData.copyText}</a
        >
      {/if}
    </div>
  </div>
</section>

<!-- <Snackbar
    labelText={$_(getStr("pdp.couponCodeSuccess"))}
    class="demo-success"
    bind:this={snackbarWithoutClose}
>
    <Label></Label>
</Snackbar> -->
<ExtraSnackBar />

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .coupon-container {
    background-color: $primary-white;
    padding: 8px;
    border-radius: 8px;

    .coupon-div {
      display: flex;
      align-items: center;
      gap: 4px;
      a.copy-code {
        text-decoration: none;
        color: $icon-only-icon-blue;
        white-space: nowrap;
        font-weight: 500;
        font-size: 12px;
        line-height: 14px;
        cursor: pointer;
        margin: 0 4px;
      }
      .description {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;

        @include desktop-min-width {
          font-size: 16px;
          line-height: 18px;
        }
        :global {
          .divider {
            margin: 0 8px;
            height: 24px;
          }
        }
      }
    }
  }
</style>
